import { Loader2 } from 'lucide-react'
import type { ReactNode } from 'react'
import { LogoMark } from './Logo'

/** Whole-screen status used before the app shell can render (sign-in, fatal config errors). */
export function FullPageMessage({
  title,
  description,
  action,
  busy,
}: {
  title: string
  description?: ReactNode
  action?: ReactNode
  busy?: boolean
}) {
  return (
    <div className="grid min-h-dvh place-items-center bg-bg p-6">
      <div className="w-full max-w-sm text-center">
        <LogoMark className="mx-auto size-10" />
        <h1 className="type-display mt-5 flex items-center justify-center gap-2 text-xl text-ink">
          {busy && <Loader2 className="size-4 animate-spin text-ink-3" aria-hidden />}
          {title}
        </h1>
        {description && <p className="mt-1.5 text-sm text-ink-2">{description}</p>}
        {action && <div className="mt-5 flex justify-center">{action}</div>}
      </div>
    </div>
  )
}
